export default "__VITE_ASSET__FioC17aa__"